/** Turns the sign over without reading the number: an empty field becomes "-" so the digits can follow. */
export function flipSign(value: string): string {
  const trimmed = value.trim();
  if (trimmed.startsWith('-')) return `+${trimmed.slice(1)}`;
  if (trimmed.startsWith('+')) return `-${trimmed.slice(1)}`;
  return `-${trimmed}`;
}
